import React, { useMemo } from "react";
import { BarChart3, RefreshCw } from "lucide-react";
import { Select } from "../Select";
import { EmptyState } from "../../../../../components/shared/loading/EmptyState";
import { LoadingSpinner } from "../../../../../components/shared/loading/LoadingSpinner";

const MobileStandingsView = ({
  standings,
  filters,
  onFilterChange,
  leagues,
  seasons,
  loading,
  onRefresh,
  t
}) => {
  const seasonOptions = useMemo(() => (
    seasons?.map((season) => ({
      value: season,
      label: `${season} ${t('Season')}`
    })) || []
  ), [seasons, t]);

  return (
    <section className="space-y-4">
      <div className="rounded-2xl border border-white/10 bg-white/[0.02]">
        <div className="flex items-center justify-between border-b border-white/5 px-4 py-3">
          <h2 className="text-lg font-black uppercase tracking-tight text-white flex items-center gap-2">
            {t('League Standings')}
          </h2>
          {filters.league && filters.season && (
            <span className="text-[11px] font-mono uppercase tracking-[0.3em] text-white/40">
              {filters.league} — {filters.season}
            </span>
          )}
        </div>

        {loading ? (
          <LoadingSpinner message={t('Loading standings...')} />
        ) : !filters.league || !filters.season ? (
          <EmptyState
            title={t('Select a league and season')}
            description={t('Standings will appear once both filters are selected.')}
            icon={BarChart3}
          />
        ) : standings.length === 0 ? (
          <EmptyState
            title={t('No standings found')}
            description={t('Try refreshing or selecting another season.')}
            icon={BarChart3}
          />
        ) : (
          <div className="divide-y divide-white/5">
            {standings.map((team, index) => (
              <div
                key={team.team?.id || index}
                className="flex items-center justify-between px-4 py-4"
              >
                <div className="flex items-center gap-3">
                  <div className={`flex h-10 w-10 items-center justify-center rounded-xl text-sm font-black ${
                    index < 4 ? 'bg-white text-black' : 'bg-white/10 text-white'
                  }`}>
                    {team.position || index + 1}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-white">
                      {team.team?.name || t('Team')}
                    </p>
                    <p className="text-xs text-white/60">
                      {t('GP')}: {team.games?.played || 0}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xs text-white/50">
                    {t('W')} {team.games?.wins || 0} · {t('L')} {team.games?.loses || 0}
                  </p>
                  <p className="text-xs text-white/50">
                    {t('Sets')} {team.sets?.for || 0}-{team.sets?.against || 0}
                  </p>
                  <p className="text-lg font-black text-white">{team.points || 0} {t('PTS')}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default MobileStandingsView;
